<template>
      <a-col>
        <div>
          <label class="from_input_title" :class="fieldRequiredColorData.nameErrorStr">姓名<span class="required_star">*</span></label>
          <a-input size="large" v-model="name" @change="passProvisioningInfo(info)">
            <a-tooltip v-if="this.currentInfo.isNameEmpty || this.currentInfo.hasNameIllegalCharaters" slot="suffix">
              <a-icon type="warning" style="color: #FF6565" />
            </a-tooltip>
          </a-input>
          <p class="errTips" v-if="this.currentInfo.isNameEmpty">請輸入姓名</p>
          <p class="errTips">{{this.currentInfo.hasNameIllegalCharaters ? '符號僅能包含：.-_': ''}}</p>
        </div>
        <div>
          <label class="from_input_title" :class="fieldRequiredColorData.carNoErrorStr">車號<span class="required_star">*</span></label>
          <a-input size="large" v-model="carNo" placeholder="車號須包含「-」" @change="passProvisioningInfo(info)">
              <a-tooltip v-if="this.currentInfo.isCarNoInvaild" slot="suffix">
              <a-icon type="warning" style="color: #FF6565" />
            </a-tooltip>         
          </a-input>
          <p class="errTips">{{this.currentInfo.isCarNoInvaild ? '請輸入車號' : ''}}</p>
        </div>
        <div>
          <label class="from_input_title" :class="fieldRequiredColorData.phoneErrorStr">手機號碼<span class="required_star">*</span></label>
          <a-input size="large" v-model="phone" placeholder="09xx-xxx-xxx" @change="passProvisioningInfo(info)">
            <a-tooltip v-if="this.currentInfo.isPhoneInvaild" slot="suffix">
              <a-icon type="warning" style="color: #FF6565" />
            </a-tooltip>          
          </a-input>
          <p class="errTips">{{this.currentInfo.isPhoneInvaild ? '請輸入手機號碼' : ''}}</p>
        </div>
      </a-col>
</template>

<script>
    import { bus } from '../../main';
    export default {
        data() {
          return {
            name: '',
            carNo: '',
            phone: '',
            currentInfo: {},                
          }
        },
        created() {
            bus.$on("passInfoStateObj", data => {
                console.log('return obj', data);
                this.currentInfo = data;
            });
        },
        mounted() {
          sessionStorage.setItem('name', this.name);
          sessionStorage.setItem('carNo', this.carNo);
          sessionStorage.setItem('phone', this.phone);
          sessionStorage.setItem('currentInfo', JSON.stringify({
            isNameEmpty: false,
            hasNameIllegalCharaters: false,
            isCarNoInvaild: false,
            isPhoneInvaild: false,
          }));
        },
        methods: {
          passProvisioningInfo(payload) {
            this.forcePhoneFormat();
            bus.$emit('passProvisioningInfo', payload);
          },
          forcePhoneFormat() {
            console.log(this.phone, this.phone.length);
            // 強制手機號碼第一碼為0
            if (this.phone.length === 1) this.phone = '0';
            // 強制手機號碼第二碼為9
            if (this.phone.length === 2) this.phone = '09';

            // 當目前的號碼長度是5，自動補上'-'做分隔(考慮按下返回鍵，長度從6變5)
            if (this.phone.length === 5) {
              if (this.phone.charAt(4) !== '-') {
                this.phone = `${this.phone.slice(0, -1)}-${this.phone.slice(-1)}`;
              }
            }
            // 當目前的號碼長度是9，自動補上'-'做分隔(考慮按下返回鍵，長度從10變9)
            else if (this.phone.length === 9) {
              if (this.phone.charAt(8) !== '-') {
                this.phone = `${this.phone.slice(0, -1)}-${this.phone.slice(-1)}`;
              }
            }
            else {
              // 檢查輸入的最後一個字元，是否有非數字的
              if (/[^\d]/g.test(this.phone.charAt(this.phone.length - 1))) this.phone = this.phone.slice(0, -1);
            }
          }
        },
        computed: {
          info: function() {
            console.log('current infoValue in computed',{
              name: this.name,
              carNo: this.carNo,
              phone: this.phone,
            });
            return {
              name: this.name,
              carNo: this.carNo,
              phone: this.phone,
            }
          },
          fieldRequiredColorData: function() {
            return {
              nameErrorStr: (this.currentInfo.isNameEmpty || this.currentInfo.hasNameIllegalCharaters ?  'title_error_color' : ''),
              carNoErrorStr: (this.currentInfo.isCarNoInvaild ?  'title_error_color' : ''),
              phoneErrorStr: (this.currentInfo.isPhoneInvaild ?  'title_error_color' : ''),
            }
          }
        },
        activated() {
          this.name = sessionStorage.getItem('name');
          this.carNo = sessionStorage.getItem('carNo');
          this.phone = sessionStorage.getItem('phone');
          this.currentInfo = JSON.parse(sessionStorage.getItem('currentInfo'));
          this.passProvisioningInfo(this.info);
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";

  .errTips {
    margin-top:4px;
    color: #FF6565;
    line-height: 24px;
  }

  .title_error_color.from_input_title {
    color: #FF6565;
  }

  .ant-input {
      border-radius: 8px;
      border: 1px solid rgba(19, 34, 149, 0.1);
      &:focus {
        border-color: #C0E560;
        box-shadow: none;
      }
  }

</style>